module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-02.d14ba02f.jpeg";